import { FC } from 'react'
import { Button, Modal, Stack, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { CLEAR_MAP_OVERLAY_PROPS } from './constants'

type VersionWarningModalProps = {
  opened: boolean
  onConfirm: () => void
  onCancel: () => void
  title: string
  message: string
  confirmLabel?: string
}

export const VersionWarningModal: FC<VersionWarningModalProps> = ({
  opened,
  onConfirm,
  onCancel,
  title,
  message,
  confirmLabel,
}) => {
  const { t } = useTranslation(['routePlanner', 'common'])

  return (
    <Modal opened={opened} onClose={onCancel} title={title} centered overlayProps={CLEAR_MAP_OVERLAY_PROPS}>
      <Stack>
        <Text size="sm">{message}</Text>
        <Button color="orange" onClick={onConfirm}>
          {confirmLabel ?? t('continue')}
        </Button>
        <Button variant="default" onClick={onCancel}>
          {t('cancel', { ns: 'common' })}
        </Button>
      </Stack>
    </Modal>
  )
}

export default VersionWarningModal
